import React from "react"
import Layout from "../components/layout/Layout"
import Sidebar from "../components/layout/Sidebar"

function WebShows() {
  return <Layout title={"TMP - Webshows"}>{/* <Sidebar /> */}</Layout>
}

export default WebShows
